import { render, staticRenderFns } from "./CommonImageViewer.vue?vue&type=template&id=78e72488&"
import script from "./CommonImageViewer.vue?vue&type=script&lang=ts&"
export * from "./CommonImageViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports